import React from 'react';
import { createBrowserRouter } from 'react-router';
import { NotFoundState } from '@oniratec/onira-react-ui';

import { AuthLayout } from './layouts/AuthLayout';
import { DashboardLayout } from './layouts/DashboardLayout';
import { RootLayout } from './layouts/RootLayout';
import { authChildren } from '@/routes/childrens/auth';
import { dashboardChildren } from '@/routes/childrens/dashboard';
import { publicChildren } from '@/routes/childrens/public';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: (
      <>
        <NotFoundState
          title="Página no encontrada"
          actionLabel="Volver al inicio"
          onAction={() => window.location.assign('/dashboard')}
        />
      </>
    ),
    children: [
      {
        path: 'auth',
        element: <AuthLayout />,
        children: authChildren,
      },
      {
        element: <DashboardLayout />,
        children: dashboardChildren,
      },
      {
        path: 'p',
        children: publicChildren,
      },
      {
        path: '*',
        element: (
          <NotFoundState
            title="Página no encontrada"
            actionLabel="Volver al inicio"
            onAction={() => window.location.assign('/dashboard')}
          />
        ),
      },
    ],
  },
]);
